export const DEFAULT_PATH = '/kiosk/adm';

const Util = {};

Util.isValidIpAddress = (ipAddress) => {
  if (
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      ipAddress
    )
  ) {
    return true;
  }
  return false;
};

function padOneZero(n) {
  if (n === 0) {
    return '00';
  }
  if (n < 10) {
    return '0' + String(n);
  }
  if (n >= 10) {
    return String(n);
  }
}

function parseDate(dateStr) {
  if (dateStr instanceof Date) {
    return dateStr;
  }
  try {
    return new Date(dateStr);
  } catch (e) {
    console.warn('extractDate: error parsing: ' + dateStr);
    return dateStr;
  }
}

Util.parseDate = parseDate;

// local date time in "YYYY-mm-dd HH:MM:ss" format
Util.localDateTimeString = (date) => {
  if (!date) {
    return '';
  }
  date = parseDate(date);
  if (!(date instanceof Date)) {
    return date;
  }

  let year = date.getFullYear();
  let month = padOneZero(date.getMonth() + 1); // getMonth() returns (0-11)
  let day = padOneZero(date.getDate()); // getDate() returns (1-31). d.getDay() returns weekday as number (0-6)
  let hours = padOneZero(date.getHours());
  let minutes = padOneZero(date.getMinutes());
  let seconds = padOneZero(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// local date in "YYYY-mm-dd" format if date is parsable string or valid date object
Util.localDateString = (date) => {
  if (!date) {
    return '';
  }
  date = parseDate(date);
  if (!(date instanceof Date)) {
    return date;
  }

  let year = date.getFullYear();
  let month = padOneZero(date.getMonth() + 1); // getMonth() returns (0-11)
  let day = padOneZero(date.getDate()); // getDate() returns (1-31). d.getDay() returns weekday as number (0-6)

  return `${year}-${month}-${day}`;
};

// local date time in "HH:MM:ss" format
Util.localTimeString = (date) => {
  if (!date) {
    return '';
  }
  date = parseDate(date);
  if (!(date instanceof Date)) {
    return date;
  }

  let hours = padOneZero(date.getHours());
  let minutes = padOneZero(date.getMinutes());
  let seconds = padOneZero(date.getSeconds());

  return `${hours}:${minutes}:${seconds}`;
};

const SECOND = 1000; // milliseconds
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

Util.xUnitsOfTimeAgo = function (fromDate, toDate = new Date()) {
  fromDate = parseDate(fromDate);
  toDate = parseDate(toDate);
  let fromTime = fromDate.getTime();
  let toTime = toDate.getTime();
  let diffDays = Math.abs((fromTime - toTime) / DAY);
  let diffHours = Math.abs((fromTime - toTime) / HOUR);
  let diffMins = Math.abs((fromTime - toTime) / MINUTE);
  let diffSecs = Math.abs((fromTime - toTime) / SECOND);
  //console.log(fromDate, toDate, diffDays, diffHours, diffMins, diffSecs);
  if (diffDays > 1) {
    return parseInt(diffDays, 10) + ' days ago';
  }
  if (diffHours > 1) {
    return parseInt(diffHours, 10) + ' hours ago';
  }
  if (diffMins > 1) {
    return parseInt(diffMins, 10) + ' minutes ago';
  }
  if (diffSecs > 0) {
    return parseInt(diffSecs, 10) + ' seconds ago';
  }
  return 'unknown';
};

Util.moreThanXHoursAgo = function (fromDate, xHours) {
  let toDate = new Date();
  fromDate = parseDate(fromDate);
  let fromTime = fromDate.getTime();
  let toTime = toDate.getTime();
  let diffHours = Math.round(Math.abs((fromTime - toTime) / HOUR));
  return diffHours > xHours;
};

Util.moreThanXMinutesAgo = function (fromDate, xMinutes) {
  let toDate = new Date();
  fromDate = parseDate(fromDate);
  let fromTime = fromDate.getTime();
  let toTime = toDate.getTime();
  let diffMinutes = Math.round(Math.abs((fromTime - toTime) / MINUTE));
  return diffMinutes > xMinutes;
};

// Based on: http://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
Util.download = function (content, fileName, mimeType) {
  let a = document.createElement('a');
  mimeType = mimeType || 'application/octet-stream';

  if (navigator.msSaveBlob) {
    // IE10
    return navigator.msSaveBlob(new Blob([content], { type: mimeType }), fileName);
  } else if ('download' in a) {
    //html5 A[download]
    a.href = 'data:' + mimeType + ',' + encodeURIComponent(content);
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  } else {
    //do iframe dataURL download (old ch+FF):
    let f = document.createElement('iframe');
    document.body.appendChild(f);
    f.src = 'data:' + mimeType + ',' + encodeURIComponent(content);

    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
    return true;
  }
};

Util.downloadCSV = (hostInfoList, name = 'hosts') => {
  // console.log('handleExportCVS');
  let data = `HostInfo ID,Host Fingerprint,IP Address,Hostname,Auth Type`;
  data += `,Network Interface,Mac Address,External IP,Timezone,Uptime,UpSince`;
  data += `,Memory Used %,Memory Total,Disk(/) Used %,Disk(/) Total`;
  data += `,Org,Location,Kiosk Name,Kiosk Type, Kiosk HW, Kiosk ID,Kiosk Tag,Deployment Set`;
  data += `,TouchScreen, Touchscreen Type,Touch Driver,Kiosk ISO`;
  data += `,printapi,payapi,capui,kskapi,cafeapi,heatwave,linuxdash,kiosk-probe`;
  data += `,Apriva Port Check,ksk.dbx,sales.dbx,cc.dbx`;
  data += `,MSR,Printer,Scale,BarcodeScanner,BillAcceptor,Fingerprint Reader,Camera`;
  data += `,Pending Print Jobs,Has Default Printer,CC Local Count,CC Quarantine Count`;
  data += `,GoLive,Deployed In SosDB,SosDB Org,SosDB Location,SosDB Kiosk Name,SalesHeader Count,SalesPayment Count`;
  data += `,Last TransId,Last TransDate,Last Poll`;
  data += `,CPU 1 Min Load Avg,CPU 5 Min Load Avg,CPU 15 Load Avg,Total Processes`;
  data += `,OS,Installed At,Last Successful Fetched,Last Updated,Date Created`;
  data += '\n';

  for (let hostInfo of hostInfoList) {
    for (let k of Object.keys(hostInfo)) {
      // console.log(k + ' => ' + hostInfo[k]);
      if (typeof hostInfo[k] === 'string' && /,/.test(hostInfo[k])) {
        console.log(k + ' has comma: ' + hostInfo[k]);
        // some data can has comma
        // hostInfo[k] = hostInfo[k].replace(/,/g,' ');
        hostInfo[k] = '"' + hostInfo[k] + '"';
      }
    }

    console.log(hostInfo.orgName);
    let {
      id,
      fingerprint,
      ip,
      hostname,
      authType,
      iface,
      macAddress,
      externalIP,
      timezone,
      uptime,
      upsince,
      memUsedPercent,
      memTotal,
      diskUsedPercent,
      diskTotal,
      orgName,
      locationName,
      kioskName,
      kioskType,
      kioskHW,
      kioskId,
      sosdbTag,
      sosdbDeploymentSet,
      touchscreen,
      touchscreenType,
      kioskTouchDriver,
      kioskISOVersion,
      printapiVersion,
      payapiVersion,
      capuiVersion,
      kskapiVersion,
      cafeapiVersion,
      heatwaveVersion,
      linuxdashVer,
      kioskprobeVersion,
      ciscoampVersion,
      cortexAgentVersion,
      aprivaPortCheck,
      kskdbx,
      salesdbx,
      ccdbx,
      usbMSR,
      usbPrinter,
      usbScale,
      usbBarcodeScanner,
      usbBillAcceptor,
      usbFingerprintReader,
      usbWebCam,
      cupsPendingPrintJobs,
      cupsHasDefaultPrinter,
      kskdbCCLocalCount,
      kskdbCCQuarantineCount,
      sosdbGoLive,
      hasSosdbKiosk,
      sosdbOrgName,
      sosdbLocName,
      sosdbKioskName,
      kskdbSahCount,
      kskdbSapCount,
      sosdbLastTransId,
      sosdbLastTransDate,
      kskLastPoll,
      cpu1MinLoadAvgPercent,
      cpu5MinLoadAvgPercent,
      cpu15MinLoadAvgPercent,
      totalProcesses,
      os,
      installedAt,
      lastFetchedDateTime,
      lastUpdated,
      dateCreated,
    } = hostInfo;

    let row = '';
    row += `${id},${fingerprint},${ip},${hostname},${authType}`;
    row += `,${iface},${macAddress},${externalIP},${timezone},${uptime},${upsince}`;
    row += `,${memUsedPercent},${memTotal},${diskUsedPercent},${diskTotal}`;
    row += `,${orgName},${locationName},${kioskName},${kioskType},${kioskHW},${kioskId},${sosdbTag},${sosdbDeploymentSet}`;
    row += `,${touchscreen},${touchscreenType},${kioskTouchDriver},${kioskISOVersion}`;
    row += `,${printapiVersion},${payapiVersion},${capuiVersion},${kskapiVersion},${cafeapiVersion},${heatwaveVersion},${linuxdashVer},${kioskprobeVersion},${ciscoampVersion}, ${cortexAgentVersion}`;
    row += `,${aprivaPortCheck},${kskdbx},${salesdbx},${ccdbx}`;
    row += `,${usbMSR},${usbPrinter},${usbScale},${usbBarcodeScanner},${usbBillAcceptor},${usbFingerprintReader},${usbWebCam}`;
    row += `,${cupsPendingPrintJobs},${cupsHasDefaultPrinter},${kskdbCCLocalCount},${kskdbCCQuarantineCount}`;
    row += `,${sosdbGoLive},${hasSosdbKiosk},${sosdbOrgName},${sosdbLocName},${sosdbKioskName},${kskdbSahCount},${kskdbSapCount}`;
    row += `,${sosdbLastTransId},${sosdbLastTransDate},${kskLastPoll}`;
    row += `,${cpu1MinLoadAvgPercent},${cpu5MinLoadAvgPercent},${cpu15MinLoadAvgPercent},${totalProcesses}`;
    row += `,${os},${installedAt},${lastFetchedDateTime},${lastUpdated},${dateCreated}`;
    row = row.replace(/,undefined/g, ','); // remove 'undefined'
    data += row + '\n';
  }
  // console.log(data);
  let dateStr = Util.localDateString(new Date());
  Util.download(data, `${name.replace(' ', '_')}-${dateStr}.csv`, 'text/csv');
};

Util.getBrowserUrlQueryParams = function () {
  if (!window || !window.location || !window.location.search) {
    return {};
  }

  let a = window.location.search.substr(1).split('&');
  let q = {};
  for (let i = 0; i < a.length; ++i) {
    let p = a[i].split('=', 2);
    if (p.length === 1) {
      q[p[0]] = '';
    }
    else q[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
  }
  return q;
};

Util.getNextPathAfterLogin = function (query) {
  query = query || Util.getBrowserUrlQueryParams();
  if (query && query.next) {
    return query.next;
  }

  let curPath = window.location.pathname;
  if (curPath.startsWith('/login') || curPath.startsWith('/logout')) {
    curPath = DEFAULT_PATH; // default path
  }
  return curPath;
};

// returns "Y" or "N"
Util.toYN = function (value) {
  if (typeof value === 'boolean') {
    return value ? 'Y' : 'N';
  }
  return /^Y$/i.test(value) ? 'Y' : 'N';
};

// returns true or false
Util.fromYN = function (value) {
  if (typeof value === 'boolean') {
    return value;
  }
  return /^Y$/i.test(value);
};

Util.jsonParse = function (str, defaultVal = {}) {
  try {
    if (typeof str === 'object') {
      return str;
    }
    return typeof str === 'string' ? JSON.parse(str) : defaultVal;
  } catch (e) {
    //console.warn(str, defaultVal, e);
  }
  return defaultVal;
};

Util.removeUserAndPassFromURL = function (url) {
  let a = document.createElement('a');
  a.href = url;
  a.username = '';
  a.password = '';
  return a.href;
};

Util.getProxyPathForKiosk = function (hostInfo, port, forceDirectIPAddr = false) {
  let path = '';
  if (hostInfo.isMQKskType && !hostInfo.kskUseVpnIPAddr) {
    path = `/api/msgapi/${hostInfo.kioskName}/localhost:${port}`;
  } else {
    path = `/api/${hostInfo.ip}:${port}`;
  }

  if (forceDirectIPAddr) {
    path = `/api/${hostInfo.ip}:${port}`;
  }
  return path;
};

Util.getKskApiPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 8188);
};

Util.getCafeApiPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 8185);
};

Util.getDirectKskApiPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 8188, true);
};

Util.getPayApiPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 8183);
};

Util.getPrintApiPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 8184);
};

Util.getLinuxDashPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 5555);
};

Util.getDirectLinuxDashPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 5555, true);
};

Util.getCapUIPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 3000);
};

Util.getDirectCapUIPath = function (hostInfo) {
  return Util.getProxyPathForKiosk(hostInfo, 3000, true);
};

Util.calcMemUsageColor = function (percent) {
  if (percent > 50 && percent < 75) {
    return 'darkorange';
  }
  if (percent >= 75) {
    return 'red';
  }
  return 'green';
};

Util.calcDiskUsageColor = function (percent) {
  if (percent > 25 && percent < 50) {
    return 'darkorange';
  }
  if (percent >= 50) {
    return 'red';
  }
  return 'green';
};

Util.calcLoadAvgColor = function (percent) {
  if (percent > 75 && percent < 100) {
    return 'darkorange';
  }
  if (percent >= 100) {
    return 'red';
  }
  return 'green';
};

Util.calcHostInfoRowOpacity = function (host) {
  let opacity = 1;

  if (host.isBadFetchStatus) {
    opacity = 0.8;
  }
  if (host.isOldFetchStatus) {
    opacity = 0.35;
  }
  return opacity;
};

// Based on: https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
Util.escapeStringRegexp = function (patternStr) {
  if (typeof patternStr !== 'string') {
    throw new TypeError('Expected a string');
  }

  return patternStr.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'); // $& means the whole matched string
};

Util.createRegexp = function (pattern, flags) {
  pattern = Util.escapeStringRegexp(pattern);
  return new RegExp(pattern, flags);
};

Util.createRegexpExactMatch = function (pattern, flags) {
  if (typeof pattern === 'boolean' || typeof pattern === 'number') {
    pattern = String(pattern);
  }
  pattern = Util.escapeStringRegexp(pattern);
  return new RegExp('^' + pattern + '$', flags);
};

export default Util;



// WEBPACK FOOTER //
// ./src/Util.js